
<div class="page">
    <h1 class="page-title">Mentions légales</h1>
    <div class="page-content">
        <h2>Éditeur</h2>
        <p class="gs1-spacer-4 gs1-little">L’ESPACE CLIENT est édité par :</p>
        <div class="coord card static gs1-spacer-4">
            <div class="gs1-logo"></div>
            <div>
                <h5>GS1 France</h5>
                <p class="gs1-color-ui-6 gs1-little">Société par actions simplifiée à capital variable, au capital plancher de 250.000 Euros</p>
                <p class="gs1-little">21 boulevard Haussmann - 75009 Paris</p>
                <p class="gs1-little">Téléphone : 01.40.22.18.00</p>
                <p class="gs1-little">RCS Paris 305 545 675 <br/>APE 8299Z - TVA FR 35 305 545 675</p>
            </div>
        </div>
        <p class="gs1-little">
            GS1 France fait ses meilleurs efforts pour assurer l'exactitude et la mise
            à jour des informations diffusées sur l’ESPACE CLIENT, dont elle se réserve
            le droit de corriger, à tout moment et sans préavis, le contenu. Toutefois,
            GS1 France ne peut garantir l'exactitude, la précision ou l'exhaustivité
            des informations mises à la disposition sur cet ESPACE CLIENT.
        </p>
        <p class="gs1-little">
            En conséquence, GS1 France décline toute responsabilité :
        </p>
        <ul>
            <li class="gs1-little">pour toute interruption de l’ESPACE CLIENT</li>
            <li class="gs1-little">survenance de bogues</li>
            <li class="gs1-little">pour toute inexactitude ou omission portant sur des informations disponibles sur l’ESPACE CLIENT</li>
            <li class="gs1-little">pour tous dommages résultant d'une intrusion frauduleuse d'un tiers ayant entraîné une modification des informations mises à la disposition sur l’ESPACE CLIENT</li>
            <li class="gs1-little">et plus généralement de tout dommage direct et indirect, quelles qu'en
                soient les causes, origines, natures ou conséquences en ce y compris
                notamment les coûts pouvant survenir du fait de l'acquisition de biens
                proposés sur l’ESPACE CLIENT, les pertes de profits, de clientèle, de
                données ou tout autre perte de biens incorporels pouvant survenir à raison
                de l'accès de quiconque à l’ESPACE CLIENT ou de l'impossibilité d'y accéder
                ou du crédit accordé à une quelconque information provenant directement ou
                indirectement de ce dernier.
            </li>
        </ul>
        <h2>Propriété intellectuelle</h2>
        <p class="gs1-little">
            GS1 France ne concède aucune licence, ni aucun autre droit que celui de
            consulter et/ou utiliser le présent ESPACE CLIENT. La reproduction de tous
            documents publiés sur l’ESPACE CLIENT est seulement autorisée aux fins
            exclusives d'information pour un usage personnel et privé, toute
            reproduction et toute utilisation de copies réalisées à d'autres fins étant
            expressément interdites.
        </p>
        <p class="gs1-little">
            Tous les éléments de cet ESPACE CLIENT (notamment les marques déposées, les
            textes, définitions, classifications, graphismes, logos, sons, photos,
            animations, contenus éditoriaux, pages web, codes sources) sont la
            propriété exclusive de GS1 France et/ou GS1 AISBL. GS1 France est une
            marque déposée, propriété exclusive de GS1 France.
        </p>
        <p class="gs1-little">
            La protection de cet ESPACE CLIENT relève des législations nationales et
            transnationales relatives au droit de la propriété intellectuelle. De la
            sorte, toute reproduction et/ou représentation et/ou diffusion de ce
            dernier ou des éléments le composant, en tout ou partie, sur quelque
            support que ce soit, présent ou futur, est interdite et ce dans le monde
            entier et pour toute la durée de protection des droits de propriété
            intellectuelle, sauf autorisation expresse et préalable de GS1 France.
        </p>
        <p class="gs1-little">
            La création de liens hypertextes vers le présent ESPACE CLIENT ne peut de
            même être effectuée qu’après autorisation expresse et préalable de GS1
            France.
        </p>
        <p class="gs1-little">
            Il est également interdit de copier, modifier, créer une œuvre dérivée,
            inverser la conception ou l'assemblage ou de toute autre manière tenter de
            trouver le code source (à l'exception des cas prévus par la loi), vendre,
            attribuer, sous-licencier ou transférer de quelque manière que ce soit tout
            droit afférent aux logiciels. De même, il est également interdit de
            modifier le logiciel ou d'utiliser des versions modifiées des logiciels et
            notamment (sans que cette énumération soit limitative) en vue d'obtenir un
            accès non autorisé au service et d'accéder à l’ESPACE CLIENT par un autre
            moyen que par l'interface fournie par GS1 France à cet effet.
        </p>
        <p class="gs1-little">
            Le non-respect de ces interdictions constitue un acte de contrefaçon
            susceptible d’engager la responsabilité pénale de tout contrevenant. Ainsi
            toute tentative d’extraction frauduleuse est susceptible de constituer un
            acte de contrefaçon répréhensible pénalement.
        </p>
    </div>
    
</div>
